import { css } from 'styled-components';
import { rgba } from 'polished';
import { colors, isDefaultThemeMode } from 'core/theme';
import ButtonBase from './ButtonBase';
import styled from 'styled-components';

const accessibilityHoverInvert = (props) => {
  if (!isDefaultThemeMode(props)) {
    return css`
      &:hover {
        background-color: ${colors.text};
        color: ${colors.background};
      }
    `;
  }
};
// BUG  ButtonBase.extend
// pretrunā ar https://www.styled-components.com/docs/faqs#when-should-i-use-

const ButtonText = ButtonBase.extend`

  background-color: transparent;
  color: ${props => props.disabled ? colors.disabled : colors.accent};

  ${({disabled}) => !disabled && css`
    &:hover {
      color: ${props => colors.accent(props, 'light')};
    }

    &:active {
      ${props => isDefaultThemeMode(props) && css`
        background-color: ${rgba(colors.accent(props)(props), 0.12)};
      `};
      color: ${props => colors.accent(props, 'dark')};
    }
  `}

  ${accessibilityHoverInvert};
`;

export default ButtonText;



// WEBPACK FOOTER //
// ./src/elements/Button/styled/ButtonText.js